import React, {
  useEffect,
  useLayoutEffect,
  Fragment,
  useState,
  useRef,
} from "react";
import Slider from "react-slick";
import { Link, useLocation } from "react-router-dom";
import { slickDot } from "../page-demo/script";
import Scrollspy from "react-scrollspy";
import ScrollToTop from "react-scroll-up";
import { FiChevronUp, FiX, FiMenu } from "react-icons/fi";
import ServiceList from "../elements/service/ServiceList";
import FooterTwo from "../component/footer/FooterTwo";
import Contact from "../elements/contact/ContactTwo";
import Helmet from "../component/common/Helmet";
import { IoIosUnlock } from "react-icons/io";
import logoXrai from "../assets/images/logo/xrailogo.png";
import logoLight from "../assets/images/logo/logo-light.png";
import logoAllDark from "../assets/images/logo/logo-all-dark.png";
import "../css/BorderTable.css";
import aboutImg from "../assets/images/about/about.png";
import TabsTwo from "../elements/tab/TabTwo";
import {
  AddTextButton,
  ComentButton,
  FlexBox,
  FreeSizeBox,
  InquiryBox,
  InquiryGroupBox,
  LockIcon,
  PageNationBox,
  TableCategory,
  TableTh,
  ThFlex,
} from "../css/BorderPageStyle";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { apiKeyState } from "../atom/ApiKey";
import { apiProductsState } from "../atom/Products";
import { getCookie, removeCookie } from "../util/Cookie";
import { TokenName } from "../util/Common";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { BorderCategory, BorderListAPI } from "../api/border/BorderApi";
import {
  ListJoinState,
  PageNationMaxPageState,
  boardListState,
  categoryListState,
  pageNationState,
} from "../atom/BorderPage";
import Pagination from "../component/PageNation";

const BorderPage = () => {
  const location = useLocation();
  const history = useHistory();
  const setBoardList = useSetRecoilState(boardListState);
  const boardList = useRecoilValue(boardListState);
  const categories = useRecoilValue(categoryListState);
  const setCategories = useSetRecoilState(categoryListState);
  const [page, setPage] = useRecoilState(pageNationState);
  const [isTotalPage, setTotalPage] = useRecoilState(PageNationMaxPageState);
  const prevCategoryRef = useRef(categories.current);
  useEffect(() => {
    if (categories.current !== prevCategoryRef.current) {
      setPage(1);
      prevCategoryRef.current = categories.current;
    }
  }, [categories.current]);

  useEffect(() => {
    const borderList = async () => {
      try {
        const resp = await BorderListAPI({
          list: 10,
          page: page,
          ...(categories.current !== 0 && { category_id: categories.current }),
        });
        const modifiedList = resp.data.boards.map((item) => ({
          ...item,
          is_token: false,
        }));
        const total = Math.ceil(resp.data.total_count / 10);
        setBoardList(modifiedList);
        setTotalPage({
          page: total,
          totalCount: resp.data.total_count,
        });
      } catch (error) {
        console.log("Error", error);
        return;
      }
    };
    borderList();
  }, []);

  useEffect(() => {
    const fetchList = async () => {
      try {
        const resp = await BorderListAPI({
          list: 10,
          page: page,
          ...(categories.current !== 0 && { category_id: categories.current }),
        });
        const modifiedList = resp.data.boards.map((item) => ({
          ...item,
          is_token: false,
        }));
        const total = Math.ceil(resp.data.total_count / 10);

        setBoardList(modifiedList);
        setTotalPage({
          page: total,
          totalCount: resp.data.total_count,
        });
      } catch (error) {
        console.log("Error", error);
        return;
      }
    };
    fetchList();
  }, [page, categories.current]);

  useLayoutEffect(() => {
    const { hash } = location;
    if (hash) {
      const target = document.getElementById(hash.substring(1));
      if (target) {
        console.log(hash, target);
        setTimeout(() => {
          target.scrollIntoView({ behavior: "smooth" });
        }, 0);
      }
    }
  }, [location]);

  const menuTrigger = () => {
    document.querySelector(".header-wrapper").classList.toggle("menu-open");
  };

  const closeMenuTrigger = () => {
    document.querySelector(".header-wrapper").classList.remove("menu-open");
  };

  useEffect(() => {
    const handleScroll = () => {
      var value = window.scrollY;
      if (value > 100) {
        document.querySelector(".header--fixed").classList.add("sticky");
      } else {
        document.querySelector(".header--fixed").classList.remove("sticky");
      }
    };

    window.addEventListener("scroll", handleScroll);

    const elements = document.querySelectorAll(".has-droupdown > a");
    for (let i = 0; i < elements.length; i++) {
      elements[i].onclick = function () {
        this.parentElement.querySelector(".submenu").classList.toggle("active");
        this.classList.toggle("open");
      };
    }

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const logo = {
    // width: "20%",
    width: `150px`,
  };
  const setApiKeys = useSetRecoilState(apiKeyState);
  const setPriducts = useSetRecoilState(apiProductsState);
  const [isToken, setToken] = useState(false);

  useEffect(() => {
    const token = getCookie(TokenName);

    if (!token) {
      setToken(true);
    } else {
      setToken(false);
    }
  }, []);
  const setListJoinState = useSetRecoilState(ListJoinState);

  const haderLogout = () => {
    localStorage.clear();
    setApiKeys([]);
    setPriducts([]);
    setListJoinState([]);
    removeCookie(TokenName);
    history.push("/login");
  };

  const handleTextButton = (item) => {
    history.push({
      pathname: "/BorderPw",
      state: { item },
    });
  };

  const handleCategoryClick = (id) => {
    setCategories((prev) => ({
      ...prev,
      current: id,
    }));
  };

  return (
    <Fragment>
      <Helmet pageTitle="XRAI | (주)엑스알에이아이" />
      {/* Start Header Area  */}
      <header className="header-area formobile-menu header--fixed default-color">
        <div className="header-wrapper" id="header-wrapper">
          <div className="header-left">
            <div className="logo">
              <a href="/">
                <img
                  className="logo-1"
                  style={logo}
                  src={logoXrai}
                  alt="Logo Images"
                />
                <img className="logo-2" src={logoXrai} alt="Logo Images" />
              </a>
            </div>
          </div>
          <div className="header-right">
            <nav className="mainmenunav d-lg-block">
              <Scrollspy
                className="mainmenu"
                items={["home", "border", "contact"]}
                // currentClassName="is-current"
                offset={-200}
              >
                <li>
                  <a
                    style={{
                      cursor: `pointer`,
                    }}
                    onClick={() => history.push("/")}
                  >
                    Home
                  </a>
                </li>
                <li>
                  <a href="/#company">Company</a>
                </li>
                <li>
                  <a href="/#solution">Solution</a>
                </li>
                <li>
                  <a href="/#portfolio">Portfolio</a>
                </li>

                <li>
                  <a
                    style={{
                      color: `#ffc20e`,
                      cursor: `pointer`,
                    }}
                  >
                    Contact
                    <hr
                      color={`#ffc20e`}
                      style={{
                        height: `4px`,
                      }}
                    />
                  </a>
                </li>
                <li>
                  {isToken === true ? (
                    <a href="login">Login</a>
                  ) : (
                    <a
                      style={{
                        cursor: `pointer`,
                      }}
                      onClick={() => haderLogout()}
                    >
                      Logout
                    </a>
                  )}
                </li>
              </Scrollspy>
            </nav>
            {/* <div className="header-btn">
              <a
                className="rn-btn"
                href="https://themeforest.net/checkout/from_item/25457315?license=regular"
              >
                <span>buy now</span>
              </a>
            </div> */}
            {/* Start Humberger Menu  */}
            <div className="humberger-menu d-block d-lg-none pl--20">
              <span onClick={menuTrigger} className="menutrigger text-white">
                <FiMenu />
              </span>
            </div>
            {/* End Humberger Menu  */}
            <div className="close-menu d-block d-lg-none">
              <span onClick={closeMenuTrigger} className="closeTrigger">
                <FiX />
              </span>
            </div>
          </div>
        </div>
      </header>
      {/* <header className="header-area formobile-menu header--fixed default-color">
        <div className="header-wrapper" id="header-wrapper">
          <div className="header-left">
            <div className="logo">
              <a href="/">
                <img
                  className="logo-1"
                  style={logo}
                  src={logoXrai}
                  alt="Logo Images"
                />
                <img className="logo-2" src={logoXrai} alt="Logo Images" />
              </a>
            </div>
          </div>
        </div>
      </header> */}
      {/* End Header Area  */}

      <div className="about-area ptb--120 bg_color--5" id="company">
        <div className="about-wrapper">
          <div className="container">
            <div
              style={{
                display: `flex`,
                width: `100%`,
                justifyContent: `center`,
                fontWeight: `800`,
                fontSize: `54px`,
              }}
            >
              도입문의
            </div>
            <FreeSizeBox height="30px" />
            <FlexBox>
              <InquiryGroupBox>
                {categories?.data.map((item) => (
                  <InquiryBox
                    key={item.id}
                    $selected={categories?.current === item.id}
                    onClick={() => handleCategoryClick(item.id)}
                  >
                    {item.text}
                  </InquiryBox>
                ))}
              </InquiryGroupBox>
            </FlexBox>
            <div className="table-background">
              <table>
                <thead>
                  <tr className="table-top-tr">
                    <th className="table-top-th">번호</th>
                    <th className="table-top-th">분류</th>
                    <th className="table-top-th">제목</th>
                    <th className="table-top-th">날짜</th>
                    <th className="table-top-th">조회 수</th>
                  </tr>
                </thead>
                <tbody>
                  {boardList.length > 0 ? (
                    boardList.map((item, index) => (
                      <tr key={item.id}>
                        <td
                          className="table-td"
                          style={{
                            fontWeight: "700",
                            fontSize: "16px",
                          }}
                        >
                          {isTotalPage.totalCount - ((page - 1) * 10 + index)}
                        </td>
                        <td className="table-td">
                          <TableCategory>{item.category_name}</TableCategory>
                        </td>
                        <td className="table-td2">
                          <div style={{ fontSize: "10px", color: "gray" }}>
                            {item.company || "작성자 없음"}
                          </div>
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <div
                              onClick={() => handleTextButton(item)}
                              style={{
                                fontSize: "16px",
                                fontWeight: "700",
                                cursor: "pointer",
                              }}
                            >
                              {item.title}
                            </div>
                            {item.comment_count === 0 ? (
                              <></>
                            ) : (
                              <ComentButton>
                                답변 {item.comment_count}
                              </ComentButton>
                            )}
                            <LockIcon>
                              <IoIosUnlock />
                            </LockIcon>
                          </div>
                        </td>
                        <td className="table-td">
                          {new Date(item.created_at).toLocaleDateString()}
                        </td>
                        <td className="table-td">{item.readed_count}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan={5}
                        style={{ textAlign: "center", padding: "20px" }}
                      >
                        데이터가 없습니다.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div
              style={{
                display: `flex`,
                justifyContent: `end`,
                marginTop: `10px`,
              }}
            >
              <AddTextButton onClick={() => history.push("/addPage")}>
                작성하기
              </AddTextButton>
            </div>
            <PageNationBox>
              <Pagination
                currentPage={page}
                totalPages={isTotalPage.page}
                onPageChange={(num) => setPage(num)}
              />
            </PageNationBox>
          </div>
        </div>
      </div>
      <FooterTwo />
      {/* End Footer Style  */}
      {/* Start Back To Top */}
      <div className="backto-top">
        <ScrollToTop showUnder={160}>
          <FiChevronUp />
        </ScrollToTop>
      </div>
      {/* End Back To Top */}
    </Fragment>
  );
};

export default BorderPage;
